import { filter } from "rxjs/operators"
import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import {
	PatientModalComponent,
	TableWrapComponent,
} from "@app/utils/utils.component"

@Component({
	selector: "app-debt-patients",
	imports: [COMMON_IMPORTS, TableWrapComponent, PatientModalComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-table-wrap fieldsStr="name,credit_balance">
			@for (row of rows; track row.id) {
				<tr>
					<td>
						<app-patient-modal [id]="row.id">
							{{ row.name }}
						</app-patient-modal>
					</td>
					<td>{{ row.credit_balance }}</td>
				</tr>
			}
		</app-table-wrap>
	`,
})
export class DebtPatientsComponent extends Modalable {
	rows: any[] = []
	ngOnInit() {
		this.rows = this.store
			.getSiteDataTable("patients")
			.filter(({ credit_balance }) => credit_balance > 0)
	}
}
